// extracted by mini-css-extract-plugin
export default {"mainHeader":"SpecialtyPharmacy_mainHeader__+nrdK"};